import axios from 'axios';
import _ from 'lodash';
import Constants from '../constants';

export async function RestartDatasetImport(surveyId: number, mSuiteDatasetId: number) {
	const url = Constants.API_IMPORT_RETRY.replace('{surveyId}', surveyId.toString()).replace(
		'{mSuiteDatasetId}',
		mSuiteDatasetId.toString(),
	);

	await axios.post(url);
}
